const L = "k4UdWzLO6n";
export {
  L as DEFAULT_PLAYER_ID
};
//# sourceMappingURL=constants.mjs.map
